export const getMultiAdVideoPreviewStyles = (/* components, theme */) => ({
  adPreviewTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  previewContainer: {
    height: 280,
    width: '100%',
  },
  adPreviewHeader: {
    height: 40,
  },
  adPreviewRoot: {
    maxWidth: '540px',
    width: '100%',
    padding: 20,
    paddingBottom: 20,
    position: 'sticky',
    top: '0px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  video: {
    borderRadius: '6px',
    height: 280,
    width: '100%',
    filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
  },
  previewTag: {
    marginTop: 10,
  },
});
